"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StringUtils = exports.stringToConstantStyledString = exports.convertToSlug = exports.pad = exports.createPadder = exports.BetterStringArray = exports.safeAppend = exports.firstNotNullEmpty = exports.nullEmpty = exports.notNullEmpty = exports.StringRegex = void 0;
exports.StringRegex = {
  digitsRegex: /\b\d+\b/gi
};
var notNullEmpty = function notNullEmpty(str) {
  return str != null && str.length > 0;
};
exports.notNullEmpty = notNullEmpty;
var nullEmpty = function nullEmpty(str) {
  return !(0, exports.notNullEmpty)(str);
};
exports.nullEmpty = nullEmpty;
var firstNotNullEmpty = function firstNotNullEmpty() {
  for (var _len = arguments.length, strItems = new Array(_len), _key = 0; _key < _len; _key++) {
    strItems[_key] = arguments[_key];
  }
  for (var _i = 0, _strItems = strItems; _i < _strItems.length; _i++) {
    var item = _strItems[_i];
    if ((0, exports.notNullEmpty)(item)) {
      return item;
    }
  }
  return undefined;
};
exports.firstNotNullEmpty = firstNotNullEmpty;
var anyNullEmpty = function anyNullEmpty(strs) {
  var _iterator = _createForOfIteratorHelper(strs),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var str = _step.value;
      if ((0, exports.nullEmpty)(str)) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
};
var safeAppend = function safeAppend(str, value) {
  var ifEmptyValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, exports.notNullEmpty)(str) ? str + value : ifEmptyValue != null ? ifEmptyValue : value;
};
exports.safeAppend = safeAppend;
var BetterStringArray = /*#__PURE__*/function (_Array) {
  _inherits(BetterStringArray, _Array);
  var _super = _createSuper(BetterStringArray);
  function BetterStringArray() {
    _classCallCheck(this, BetterStringArray);
    return _super.apply(this, arguments);
  }
  _createClass(BetterStringArray, [{
    key: "pushIfNotNullEmpty",
    value: function pushIfNotNullEmpty(str) {
      if ((0, exports.notNullEmpty)(str)) {
        this.push(str);
      }
    }
  }]);
  return BetterStringArray;
}( /*#__PURE__*/_wrapNativeSuper(Array));
exports.BetterStringArray = BetterStringArray;
function createPadder(padCharacter, desiredTotalLength) {
  var padFromRight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (input) {
    return pad(input, padCharacter, desiredTotalLength, padFromRight);
  };
}
exports.createPadder = createPadder;
function pad(input, padCharacter, desiredTotalLength) {
  var padFromRight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var difference = desiredTotalLength - "".concat(input).length;
  if (difference > 0) {
    var padding = new Array(difference).fill(padCharacter);
    if (padFromRight) {
      return "".concat(input).concat(padding.join(""));
    }
    return "".concat(padding.join("")).concat(input);
  }
  return "".concat(input);
}
exports.pad = pad;
var regexAllSpaces = new RegExp("\\s+", "g");
var regexDoubleDashes = new RegExp("--+", "g");
var regexFirstDash = new RegExp("^-+", "g");
var regexLastDash = new RegExp("-+$", "g");
var regexSingleDash = new RegExp("-", "g");
var regexRemoveNonWord = new RegExp("[^\\w\\-]+", "g");
var regexAllUnderscores = new RegExp("_", "g");
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
var convertToSlug = function convertToSlug(text) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$slugDivider = _ref.slugDivider,
    slugDivider = _ref$slugDivider === void 0 ? "-" : _ref$slugDivider,
    _ref$letterCase = _ref.letterCase,
    letterCase = _ref$letterCase === void 0 ? "LOWER" : _ref$letterCase,
    _ref$normalize = _ref.normalize,
    normalize = _ref$normalize === void 0 ? true : _ref$normalize,
    _ref$excludeCharacter = _ref.excludeCharacters,
    excludeCharacters = _ref$excludeCharacter === void 0 ? [] : _ref$excludeCharacter;
  if (!text || text.length === 0) {
    return "";
  }
  var resp = text.toString();
  if (normalize) {
    resp = resp.normalize("NFD");
  }
  if (letterCase === "LOWER") {
    resp = resp.toLowerCase();
  } else if (letterCase === "UPPER") {
    resp = resp.toUpperCase();
  }
  return resp.replace(regexAllSpaces, "-") // Replace spaces with -
  .replace(excludeCharacters.length > 0 ? new RegExp("[^\\w\\-".concat(excludeCharacters.map(function (c) {
    return escapeRegExp(c);
  }).join(""), "]+"), "g") : regexRemoveNonWord, "") // Remove all non-word chars
  .replace(excludeCharacters.includes("_") ? regexAllSpaces : regexAllUnderscores, "-") // replace underscores with dashes
  .replace(regexDoubleDashes, "-") // Replace multiple - with single -
  .replace(regexFirstDash, "") // Trim - from start of text
  .replace(regexLastDash, "") // Trim - from end of text
  .replace(regexSingleDash, slugDivider); // Replace all - with whatever the slug divider is
  /*return resp
    .replace(/\s+/g, "-") // Replace spaces with -
    // .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/_/g, "-") // replace underscores with dashes
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, "") // Trim - from end of text
    .replace(/-/g, slugDivider); // Replace all - with whatever the slug divider is*/
};

exports.convertToSlug = convertToSlug;
// Replace spaces with underscores and make letters UPPERCASE:
// eg. "Some thing's" -> "SOME_THINGS"
var stringToConstantStyledString = function stringToConstantStyledString(input) {
  return (0, exports.convertToSlug)(input, {
    normalize: true,
    slugDivider: "_",
    letterCase: "UPPER"
  });
  // return input.replace(/[^\w\s]/g, "").replace("/\s+/g", "_").toUpperCase();
};

exports.stringToConstantStyledString = stringToConstantStyledString;
var reverse = function reverse(input) {
  var r = "";
  var _iterator2 = _createForOfIteratorHelper(input),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var char = _step2.value;
      r = "".concat(char).concat(r);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return r;
};
function isUriEncoded(uri) {
  uri = uri || "";
  return uri !== decodeURIComponent(uri);
}
var decodeUriFully = function decodeUriFully(uri) {
  var failSafe = 0;
  while (isUriEncoded(uri)) {
    failSafe += 1;
    uri = decodeURIComponent(uri);
    if (failSafe > 20) {
      throw new Error("String Utils: Decode URI Fully: Enacted while loop too many times with attempt to decode fully.");
    }
  }
  return uri;
};
var removeAndTrim = function removeAndTrim(input, removeText) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$spaceAware = _ref2.spaceAware,
    spaceAware = _ref2$spaceAware === void 0 ? true : _ref2$spaceAware,
    _ref2$insideWords = _ref2.insideWords,
    insideWords = _ref2$insideWords === void 0 ? false : _ref2$insideWords;
  var text = "".concat(input);
  var _iterator3 = _createForOfIteratorHelper(removeText),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var rem = _step3.value;
      if (spaceAware) {
        if (!insideWords) {
          if (text.indexOf(" ".concat(rem, " ")) >= 0) {
            text = text.replace(" ".concat(rem, " "), " ");
          } else {
            if (text.startsWith("".concat(rem, " "))) {
              text = text.substring(rem.length + 1);
            }
            if (text.endsWith(" ".concat(rem))) {
              text = text.substring(0, text.length - (rem.length + 1));
            }
          }
        } else {
          var checkNew = [new RegExp("\\s".concat(rem, "\\s"), "g"), new RegExp("\\s".concat(rem), "g"), new RegExp("".concat(rem, "\\s"), "g")];
          for (var _i2 = 0, _checkNew = checkNew; _i2 < _checkNew.length; _i2++) {
            var remNew = _checkNew[_i2];
            if (remNew.test(text)) {
              console.log("Replacing \"".concat(remNew, "\" in \"").concat(text, "\""));
              text = text.replace(remNew, " ");
              console.log("Text after: \"".concat(text, "\""));
            }
          }
        }
      } else {
        if (text.indexOf(rem) >= 0) {
          text = text.replace(rem, "");
        }
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  return text.trim();
};
function sortCompareStrings(a, b) {
  var aa = a.toLowerCase();
  var bb = b.toLowerCase();
  if (aa < bb)
    //sort string ascending
    return -1;
  if (aa > bb) return 1;
  return 0; //default return value (no sorting)
}

function comparePure(a, b) {
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  return 0;
}
function onlyNotNullEmpty(strArray) {
  var notNullEmptyArray = [];
  var _iterator4 = _createForOfIteratorHelper(strArray),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var str = _step4.value;
      if ((0, exports.notNullEmpty)(str)) {
        notNullEmptyArray.push(str);
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
  return notNullEmptyArray;
}
var joinIntoUrl = function joinIntoUrl() {
  for (var _len2 = arguments.length, routes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    routes[_key2] = arguments[_key2];
  }
  return routes.filter(function (v) {
    return v;
  }).map(function (v, i, arr) {
    var isNotFirst = i !== 0;
    var isNotLast = i !== arr.length - 1;
    if (isNotFirst) {
      v = v.startsWith("/") ? v.slice(1) : v;
    }
    if (isNotLast) {
      v = v.endsWith("/") ? v.slice(0, -1) : v;
    }
    return v;
  }).join("/");
};
var getUrlWithBaseUrl = function getUrlWithBaseUrl(baseUrl, route) {
  var isRouteCompleted = route.startsWith("http://") || route.startsWith("https://");
  if (isRouteCompleted) {
    return route;
  }
  return joinIntoUrl(baseUrl, route);
};
var isHashId = function isHashId(accountId) {
  var hash = accountId.match(/^[a-zA-Z0-9]+$/);
  return Boolean(hash);
  // accountId.match(/^[a-zA-Z0-9]{64}$/)
};

exports.StringUtils = {
  isUriEncoded: isUriEncoded,
  decodeUriFully: decodeUriFully,
  StringRegex: exports.StringRegex,
  reverse: reverse,
  notNullEmpty: exports.notNullEmpty,
  nullEmpty: exports.nullEmpty,
  anyNullEmpty: anyNullEmpty,
  safeAppend: exports.safeAppend,
  createPadder: createPadder,
  pad: pad,
  convertToSlug: exports.convertToSlug,
  stringToConstantStyledString: exports.stringToConstantStyledString,
  removeAndTrim: removeAndTrim,
  sortCompareStrings: sortCompareStrings,
  comparePure: comparePure,
  onlyNotNullEmpty: onlyNotNullEmpty,
  firstNotNullEmpty: exports.firstNotNullEmpty,
  joinIntoUrl: joinIntoUrl,
  getUrlWithBaseUrl: getUrlWithBaseUrl,
  isHashId: isHashId
};